import Provider from './components/Provider';
import connectAdvanced from './components/connectAdvanced';
import { ReactReduxContext } from './components/Context';
import connect from './connect/connect';
import { setBatch } from './utils/batch';
import { unstable_batchedUpdates as batch } from './utils/reactBatchedUpdates';
setBatch(batch);
export { Provider, connectAdvanced, ReactReduxContext, connect, batch };


//////////////////
// WEBPACK FOOTER
// ./~/react-redux/es/index.js
// module id = 22
// module chunks = 24